import { useScrollContext }  from '../../providers/ScrollProvider';
import { FaPhoneAlt } from 'react-icons/fa';
import Section from '../Section';
import Reveal from '../Reveal';
import siteData from '../../siteData';
import { handleHashNav } from '../../utils/utils';
import { useOverlay } from '../../providers/OverlayProvider';
import heroImg from '../../assets/images/hero/hero.webp';



function Hero() {
  const { setOverlay } = useOverlay();
  const { scrolled } = useScrollContext();
  
  function handleActionAlert(alert) {
    setOverlay(<>
      <div className="alert">
        {alert.type === 'call' && <FaPhoneAlt className={`icon ${alert.type}`} />}
        <h3>{alert.headline}</h3>
        <p>{alert.message}</p>
      </div>
    </>);
  }

  return (
    <Section name="Hero" type={`${scrolled && 'scrolled'} ${siteData.logo.type.includes('image') && 'has-logo'}`}>
      <div className="container">
        <div className="focus">
          <Reveal order={2} inView={false} onRender={true} className="headline">
            <h1>{siteData.hero.headline.map((seg, i) => (i % 2 === 0 ? <span className="highlight" key={i}>{seg}</span> : `${seg}`))}</h1>
          </Reveal>
          <Reveal order={3} inView={false} onRender={true} className="subheadline">
            <p>{siteData.hero.subheadline}</p>
          </Reveal>
          <div className="cta-wrapper">
            {siteData.hero.cta.main.show && (
              <Reveal order={4} inView={false} onRender={true}>
                {siteData.hero.cta.main.type === 'link' && (
                  <a 
                    href={siteData.hero.cta.main.link.url} 
                    target={siteData.hero.cta.main.link.external ? '_blank' : '_self'} 
                    rel="noopener noreferrer"
                    className="cta"
                    onClick={!siteData.hero.cta.main.link.external ? handleHashNav(siteData.hero.cta.main.link.url.substring(1)) : () => {}}
                  >
                    <p>{siteData.hero.cta.main.text}</p>
                  </a>
                )}
                {siteData.hero.cta.main.type === 'alert' && (
                  <button className="cta" onClick={() => handleActionAlert(siteData.hero.cta.main.alert)}>
                    <p>{siteData.hero.cta.main.text}</p>
                  </button>
                )}
                {siteData.hero.cta.main.type === 'directions' && (
                  <a
                    href={`https://www.google.com/maps/dir/?api=1&destination=${siteData.location.address}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="cta"
                  >
                    <p>Get Directions</p>
                  </a>
                )}
              </Reveal>
            )}
            {siteData.hero.cta.ghost.show && (
              <Reveal order={5} inView={false} onRender={true}>
                {siteData.hero.cta.ghost.type === 'link' && (
                  <a 
                    href={siteData.hero.cta.ghost.link.url} 
                    target={siteData.hero.cta.ghost.link.external ? '_blank' : '_self'} 
                    rel="noopener noreferrer"
                    className="cta ghost"
                    onClick={!siteData.hero.cta.ghost.link.external ? handleHashNav(siteData.hero.cta.ghost.link.url.substring(1)) : () => {}}
                  >
                    <p>{siteData.hero.cta.ghost.text}</p>
                  </a>
                )}
                {siteData.hero.cta.ghost.type === 'alert' && (
                  <button className="cta ghost" onClick={() => handleActionAlert(siteData.hero.cta.ghost.alert)}>
                    <p>{siteData.hero.cta.ghost.text}</p>
                  </button>
                )}
                {siteData.hero.cta.ghost.type === 'directions' && (
                  <a
                    href={`https://www.google.com/maps/dir/?api=1&destination=${siteData.location.address}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="cta ghost"
                  >
                    <p>Get Directions</p>
                  </a>
                )}
              </Reveal>
            )}
          </div>
        </div>
        <Reveal order={1} inView={false} onRender={true} className="right">
          <img 
            src={heroImg}
            alt="web design and development agency small team discussing how they can best meet the needs of their client and complete the project on time" 
          />
        </Reveal>
      </div>
    </Section>
  );
}

export default Hero;